import { useMutation } from "react-query";
import { useToasts } from "react-toast-notifications";
import StaffController from "../../../../controller/staff";



const deleteStaffMember = (id) => {
    return StaffController.deleteStaff(id)
}


export default function useDeleteStaffMember(refetch) {
    const { addToast } = useToasts();
    return useMutation(deleteStaffMember, {
        onSuccess: (data) => {
            addToast(`ოპერაცია წარმატებით შესრულდა!`, {
                appearance: "success",
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
            refetch()
        },
        onError: (error) => {
            addToast(`სერვერთან დაკავშირებისას მოხდა შეცდომა, სცადეთ თავიდან!`, {
                appearance: "error",
                autoDismiss: true,
                autoDismissTimeout: 5000,
            });
        },
    })
}